export const SOLD_OUT = 'sold_out'
export const PARSED_FAILED = 'parse_failed'
export const BLACKLIST = 'blacklist'
export const BUY_SELF = 'buy_self'
export const NOT_ON_SALE = 'not_on_sale'
